import { Debt } from '../../interfaces';

export const isEligibleECOADesignator = (debt: Debt): boolean =>
  ['individual', 'primary', 'jointContractLiability'].includes(debt.ecoaDesignator);
